/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions } from 'vuex';

import draggable from "vuedraggable";
import pdf from 'vue-pdf';

import ProjectStructure from '@/components/ProjectStructure/ProjectStructure.component.vue';
import ProjectStructureDetails from '@/components/ProjectStructure/ProjectStructureDetails.component.vue';
import ProjectStructureTree from '@/components/ProjectStructure/ProjectStructureTree.component.vue';
import ProjectStructureWidget from '@/components/ProjectStructure/ProjectStructureWidget.component.vue';
import ProjectStructureWidgetOverlay from '@/components/ProjectStructure/ProjectStructureWidgetOverlay.component.vue';
import ProjectStructurePlanPoint from '@/components/ProjectStructure/ProjectStructurePlanPoint.component.vue';
import ProjectStructurePlanEdgePoint from '@/components/ProjectStructure/ProjectStructurePlanEdgePoint.component.vue';

import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardDeleteButtonLarge from '@/components/StandardComponents/StandardDeleteButtonLarge.component.vue';

import TFinderLayout from '@/components/Taktify/TFinderLayout.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';

export const ProjectStructurePlansMixin = {
  components: {
    draggable,
    pdf,

    ProjectStructure,
    ProjectStructureDetails,
    ProjectStructureTree,
    ProjectStructureWidget,
    ProjectStructureWidgetOverlay,
    ProjectStructurePlanPoint,
    ProjectStructurePlanEdgePoint,

    StandardDataField,
    StandardDialogFullScreen,
    StandardDeleteButtonLarge,

    TFinderLayout,
    TFlex
  },
  data: () => ({
    performance_mode: false,
    plan_zoom: 1,
    plan_height: 100,
    plan_zoom_key: 0,
    // canvas_size: {height: 100, width: 100}
    plan_reference_point: {x: 25, y: 25, move: false},
    plan_scale: {
      points: [
        {x: 75, y: 25, move: false},
        {x: 275, y: 25, move: false},
      ],
      values: [
        {point: {x: 175, y: 25}, length: 10}
      ],
      pixcel_per_length: 20,
    },
    moving_point: {x: 0, y: 0},
    plan_move: {
      move: false,
      moved: false,
      initial_mouse_x: 0,
      initial_mouse_y: 0,
      initial_scrollLeft: 0,
      initial_scrollTop: 0,
    },
    plan_measurement: {
      active: false,
      rectangle: false,
      paths: [],
    },
    points: [],
    wheel_zoom: true,
    close_path: false,
    pdf_rendering: false,
    show_spatialunits: false,
    show_process_structure: false,
    spatial_elements: [
      {id: -1, type: 'sites', name: 'Site', description: '', order_index: 0, closed: false, plans: [], sites: [], buildings: [], spatialzones: [], spatialunits: []},
      {id: -1, type: 'spatialzones', name: 'Zone', description: '', order_index: 0, closed: false, plans: [], spatialzones: [], spatialunits: []},
      {id: -1, type: 'buildings', name: 'Building', description: '', order_index: 0, closed: false, plans: [], buildings: [], buildingstoreys: [], spaces: [], spatialunits: []},
      {id: -1, type: 'buildingstoreys', name: 'Storey', description: '', order_index: 0, closed: false, plans: [], buildingstoreys: [], spaces: [], spatialunits: []},
      {id: -1, type: 'spaces', name: 'Space',  description: '', order_index: 0, closed: false, plans: [], spaces: [], spatialunits: []},
      {id: -1, type: 'spatialunits', name: 'SPATIAL.unit', description: '', order_index: 0, closed: false, plans: [], elements: [], locations: [], spatialunits: []},
    ],
    selected_tree_element: false,
    locations: [],
    active_location: {
      // id: 'create',
      // plan_id: 1,
      // spatial_unit_id: 1,
      // path: []
    },
    hovered_spatial_unit: -1,
    edit_location_point: {
      active: false,
      location_id: -1,
      point_index: -1,
    },
    altKey_down: false,
    edge_point_clicked: false,
    edges: [],
    //AI Test
    // ai_mode: false,
    // canvas_factor: 1,
  }),
  computed: {
    ...mapGetters('UltraDev', [
      'getUDObject',
      'getUDObjects',
      'getUDObjectsFiltered'
    ]),
    ...mapGetters('ProjectStructure', [
      'getChildElements',
      'getParentsFloorPlans',
      'getSpatialUnitsLocation'
    ]),
    point_move() {
      let boolean = false;
      if (this.plan_reference_point.move) {
        boolean = true;
      }
      if (this.plan_measurement.active) {
        boolean = true;
      }
      this.plan_scale.points.forEach(point => {
        if (point.move) {
          boolean = true;
        }
      });
      if (this.edit_location) {
        boolean = true;
      }
      return boolean;
    },
    edit_location() {
      if (this.show_spatialunits &&
          (
            this.selected_tree_element.type !== 'spatialunits' ||
            this.locations.findIndex(location => {
               return location.spatial_unit_id === this.selected_tree_element.id;
            }) === -1 ||
            this.edit_location_point.active
          )
      ) {
        return true;
      } else {
          return false;
      }
    },
    selected_spatialunits_location() {
      if (this.selected_tree_element.type === 'spatialunits') {
        let index = this.locations.findIndex(location => {
           return location.spatial_unit_id === this.selected_tree_element.id;
        });
        if (index !== -1) {
          return this.locations[index];
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  watch: {
    plan_zoom: function() {
      // let self = this;
      this.updateCanvas();
      if (!this.performance_mode) {
        this.renderPDF();
      }

      // this.plan_zoom_key++;
      // let key_copy = JSON.parse(JSON.stringify(this.plan_zoom_key));
      // this.updateOnPlanZoom(key_copy);

    },
    'selected_plan.id': function () {
      if (this.selected_plan && this.selected_plan.plan_url !== '') {
        this.updatePlanHeight();
      }
      this.setPlanValues();
      this.setLocations();
    },
    show_spatialunits: function () {
      this.updateCanvas();
    },
    // element: function(val) {
    //   this.selected_tree_element = {type: val.type, id: val.id};
    // }
  },
  mounted() {
    if (this.selected_plan && this.selected_plan.plan_url !== '') {
      this.renderPDF();
      this.updatePlanHeight();
      this.setPlanValues();
      this.setLocations();
    }
    if (this.$route.params.plan_id === 'create') {
      this.$refs.createPlan.click();
    }
    this.selected_tree_element = {type: this.$route.params.type, id: this.$route.params.structure_id};

    this.show_spatialunits = true;
    if (this.$route.params.type === 'spatialunits') {
      this.startNewLocation({x: 500, y: 500}, this.$route.params.structure_id);
    } else if (this.$route.params.type !== 'spatialunits') {
      this.startNewLocation({x: 500, y: 500}, 'create');
    }

  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'updateUObjectParent'
    ]),
    ...mapActions('UltraDev', [
      'createUDObject',
      'updateUDObject',
      'deleteUDObject',
      'changeUDObjectParent'
    ]),
    // updateOnPlanZoom(plan_zoom_key) {
    //   let self = this;
    //   setTimeout(function () {
    //     if (plan_zoom_key === self.plan_zoom_key) {
    //       // self.updateCanvas();
    //       self.renderPDF();
    //     }
    //   }, 1000);
    // },
    setLocations() {
      this.locations = JSON.parse(JSON.stringify(this.getUDObjectsFiltered({type: 'locations', filter: {plan_id: this.selected_plan.id}})));
    },
    setPlanValues() {
      this.plan_reference_point.x = this.selected_plan.reference_x;
      this.plan_reference_point.y = this.selected_plan.reference_y;
      this.plan_scale.points[0].x = this.selected_plan.scale_x_1;
      this.plan_scale.points[0].y = this.selected_plan.scale_y_1;
      this.plan_scale.points[1].x = this.selected_plan.scale_x_2;
      this.plan_scale.points[1].y = this.selected_plan.scale_y_2;
      this.plan_scale.pixcel_per_length = this.selected_plan.pixcel_per_length;

      this.plan_scale.values[0].point.x = (this.plan_scale.points[1].x + this.plan_scale.points[0].x)/2;
      this.plan_scale.values[0].point.y = (this.plan_scale.points[1].y + this.plan_scale.points[0].y)/2;

      let length = Math.sqrt(Math.pow((this.plan_scale.points[1].x - this.plan_scale.points[0].x),2) + Math.pow((this.plan_scale.points[1].y - this.plan_scale.points[0].y),2));
      this.plan_scale.values[0].length = Math.round((length / this.plan_scale.pixcel_per_length) * 1000) / 1000;
    },
    updateCanvas(evt) {
      let self = this;
      setTimeout(function () {
        let canvas = document.getElementById('plan_canvas');
        let ctx = canvas.getContext('2d');

        ctx.clearRect(0,0, 1000 * self.plan_zoom, self.plan_height * self.plan_zoom );
        ctx.fillStyle = 'rgba(76,175,80,0.3)';
        // ctx.scale(1.2,1.2);
        // ctx.scale(self.plan_zoom, self.plan_zoom);
        // ctx.translate(0.5,0.5);

        //scale
        if (!self.plan_measurement.active && !self.show_spatialunits) {
          ctx.beginPath();
          ctx.moveTo(self.plan_scale.points[0].x * self.plan_zoom, self.plan_scale.points[0].y * self.plan_zoom);
          ctx.lineTo(self.plan_scale.points[1].x * self.plan_zoom, self.plan_scale.points[1].y * self.plan_zoom);
          ctx.closePath();
          ctx.stroke();
        }
        //measurement
        else if (self.plan_measurement.active) {
          self.plan_measurement.paths.forEach(path => {
            if (path.points.length !== 0) {
              if (!path.rectangle || path.points.length > 2) {
                ctx.beginPath();
                ctx.moveTo(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom);
                for (var i = 1; i < path.points.length; i++) {
                  ctx.lineTo(path.points[i].x * self.plan_zoom, path.points[i].y * self.plan_zoom);
                }
                if (path.area) {
                  ctx.closePath();
                  ctx.fill();
                }
                ctx.stroke();
              } else if (path.points.length > 1) {
                ctx.fillRect(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom, (path.points[1].x * self.plan_zoom - path.points[0].x * self.plan_zoom), (path.points[1].y* self.plan_zoom - path.points[0].y * self.plan_zoom));
                ctx.strokeRect(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom, (path.points[1].x * self.plan_zoom - path.points[0].x * self.plan_zoom), (path.points[1].y * self.plan_zoom - path.points[0].y * self.plan_zoom));
              }
            }
          });
        }
        //location
        else {
          self.hovered_spatial_unit = -1;
          //new location
          if (self.active_location.id === 'create') {
            let new_points = self.active_location.path.points;
            if (new_points.length > 3) {
              ctx.beginPath();
              ctx.moveTo(new_points[0].x * self.plan_zoom, new_points[0].y * self.plan_zoom);
              for (var i = 1; i < new_points.length; i++) {
                ctx.lineTo(new_points[i].x * self.plan_zoom, new_points[i].y * self.plan_zoom);
              }
              ctx.stroke();
            }
            else if (new_points.length > 1 && new_points.length < 4) {
              ctx.fillRect(new_points[0].x * self.plan_zoom, new_points[0].y * self.plan_zoom, (new_points[1].x * self.plan_zoom - new_points[0].x * self.plan_zoom), (new_points[1].y* self.plan_zoom - new_points[0].y * self.plan_zoom));
              ctx.strokeRect(new_points[0].x * self.plan_zoom, new_points[0].y * self.plan_zoom, (new_points[1].x * self.plan_zoom - new_points[0].x * self.plan_zoom), (new_points[1].y * self.plan_zoom - new_points[0].y * self.plan_zoom));
              if (new_points.length > 2) {
                ctx.beginPath();
                ctx.moveTo(new_points[1].x * self.plan_zoom, new_points[1].y * self.plan_zoom);
                ctx.lineTo(new_points[2].x * self.plan_zoom, new_points[2].y * self.plan_zoom);
                ctx.stroke();
              }
            }
          }
          //locations
          self.locations.forEach(location => {
            //color
            if (self.selected_tree_element.type === 'spatialunits' && self.selected_tree_element.id !== location.spatial_unit_id) {
              ctx.fillStyle = 'rgba(158,158,158,0.3)';
            } else {
              ctx.fillStyle = 'rgba(76,175,80,0.3)';
            }

            ctx.beginPath();
            ctx.moveTo(location.path.points[0].x * self.plan_zoom, location.path.points[0].y * self.plan_zoom);
            for (var i = 1; i < location.path.points.length; i++) {
              ctx.lineTo(location.path.points[i].x * self.plan_zoom, location.path.points[i].y * self.plan_zoom);
            }
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
            if (evt && ctx.isPointInPath(evt.x, evt.y)) {
              self.hovered_spatial_unit = location.spatial_unit_id;
            }
          });
        }
      }, 1);
    },
    updatePlanHeight() {
      let self = this;
      setTimeout(function () {
        self.plan_height = document.getElementById('plan_pdf').scrollHeight;
        self.updateCanvas();

      }, 100);
    },
    renderPDF() {
      if (!this.pdf_rendering) {
        this.pdf_rendering = true;

        let self = this;
        let url = this.selected_plan.plan_url;


        let loading_task = pdf.createLoadingTask(url);
        // Asynchronous download PDF
        loading_task.promise.then(function(pdf) {
          return pdf.getPage(1);
        })
        .then(function(page) {
          // Set scale (zoom) level
          let scale = self.plan_zoom;

          // Get viewport (dimensions)
          let viewport = page.getViewport({ scale: scale });

          // Get canvas#the-canvas
          let canvas = document.getElementById('plan_pdf');

          // Fetch canvas' 2d context
          let context = canvas.getContext('2d');

          // Set dimensions to Canvas
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          // canvas.style.height = "100%";
          // canvas.style.width = `${100 * self.plan_zoom}%`;

          // Prepare object needed by render method
          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          // Render PDF page
          let renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            self.pdf_rendering = false;
          });
        });
      }
    },
    updatePixelPerLength() {
      let length = Math.sqrt(Math.pow((this.plan_scale.points[1].x - this.plan_scale.points[0].x),2) + Math.pow((this.plan_scale.points[1].y - this.plan_scale.points[0].y),2));
      let pixcel_per_length = length / this.plan_scale.values[0].length;
      this.plan_scale.pixcel_per_length = pixcel_per_length;
      this.updateUDObject({
          url: [
            {'plans': this.selected_plan.id},
          ],
          update: {
            pixcel_per_length: pixcel_per_length,
          }
        });
    },
    // AI Test
    // saveImageSnippet(image_data) {
    //   let download_canvas = document.getElementById('image_download');
    //   let download_ctx = download_canvas.getContext('2d');
    //
    //   download_ctx.putImageData(image_data, 0, 0);
    //   let download_content = download_canvas.toDataURL('image/jpeg');
    //
    //   let link = document.createElement("a"); //create 'a' element
    //   link.href = download_content;
    //   link.download = 'test';
    //
    //   link.click(); //virtually click <a> element to initiate download
    //
    // },
    planWrapperKeyEvent(evt) {
      // AI Test
      // if (evt.key === 'Enter' && evt.type === 'keyup' && this.ai_mode) {
      //   let mouse_x = this.moving_point.x;
      //   let mouse_y = this.moving_point.y;
      //
      //
      //   let canvas = document.getElementById('plan_pdf');
      //   let ctx = canvas.getContext('2d');
      //
      //   let factor = (canvas.width / 1000);
      //
      //   this.saveImageSnippet(ctx.getImageData(mouse_x * factor - 50, mouse_y * factor - 50, 100, 100));
      // }
      //getIntersections
      if (evt.altKey && this.point_move) {

        this.altKey_down = true;
        this.edge_point_clicked = false;

        let mouse_x = this.moving_point.x;
        let mouse_y = this.moving_point.y;


        let canvas = document.getElementById('plan_pdf');
        let ctx = canvas.getContext('2d');

        let factor = (canvas.width / 1000);


        let image_data = ctx.getImageData(mouse_x * factor - 50, mouse_y * factor - 50, 100, 100).data;
        // ctx.strokeRect(mouse_x * factor - 50, mouse_y * factor - 50, 100, 100);

        //rgba = 4 values
        let rows = image_data.reduce(function (rows, key, index) {
          return (index % 4 == 0 ? rows.push([key])
            : rows[rows.length-1].push(key)) && rows;
        }, []);

        //pixels per row
        let matrix = rows.reduce(function (rows, key, index) {
          return (index % 100 == 0 ? rows.push([key])
            : rows[rows.length-1].push(key)) && rows;
        }, []);

        // matrix gedreht! y-x

        let edges = [];

        for (let y = 2; y < matrix.length-2; y++) {
          for (let x = 2; x < matrix[y].length-2; x++) {
            if (
                // lines
                !this.compArr(matrix[y][x],matrix[y-1][x-1]) &&
                !this.compArr(matrix[y][x],matrix[y-1][x+1]) &&
                !this.compArr(matrix[y][x],matrix[y+1][x+1]) &&
                !this.compArr(matrix[y][x],matrix[y+1][x-1]) &&
                // edges
                !this.compArr(matrix[y+1][x+1],matrix[y+1][x]) &&
                !this.compArr(matrix[y+1][x+1],matrix[y][x+1]) &&
                !this.compArr(matrix[y-1][x],matrix[y+1][x]) &&
                !this.compArr(matrix[y][x-1],matrix[y][x+1]) &&
                // white border
                (
                  (
                  this.compArr(matrix[y-1][x-1], [255,255,255,255]) &&
                  this.compArr(matrix[y-2][x-1], [255,255,255,255]) &&
                  this.compArr(matrix[y-1][x-2], [255,255,255,255])

                  // !this.compArr(matrix[y][x-1], [255,255,255,255]) &&
                  // !this.compArr(matrix[y-1][x], [255,255,255,255])
                  ) ||
                  (
                  this.compArr(matrix[y-1][x+1], [255,255,255,255]) &&
                  this.compArr(matrix[y-2][x+1], [255,255,255,255]) &&
                  this.compArr(matrix[y-1][x+2], [255,255,255,255])

                  // !this.compArr(matrix[y][x+1], [255,255,255,255]) &&
                  // !this.compArr(matrix[y-1][x], [255,255,255,255])

                  ) ||
                  (
                  this.compArr(matrix[y+1][x+1], [255,255,255,255]) &&
                  this.compArr(matrix[y+2][x+1], [255,255,255,255]) &&
                  this.compArr(matrix[y+1][x+2], [255,255,255,255])

                  // !this.compArr(matrix[y][x+1], [255,255,255,255]) &&
                  // !this.compArr(matrix[y+1][x], [255,255,255,255])
                  ) ||
                  (
                  this.compArr(matrix[y+1][x-1], [255,255,255,255]) &&
                  this.compArr(matrix[y+2][x-1], [255,255,255,255]) &&
                  this.compArr(matrix[y+1][x-2], [255,255,255,255])

                  // !this.compArr(matrix[y][x-1], [255,255,255,255]) &&
                  // !this.compArr(matrix[y+1][x], [255,255,255,255])
                  )
                )



              ) {
              edges.push({x: mouse_x - 50 / factor + x / factor, y: mouse_y - 50 / factor + y / factor});
            }
          }
        }
        this.edges = edges;


      } else {
        this.altKey_down = false;
        this.edge_point_clicked = false;
        this.edges = [];
      }
    },
    compArr(a,b) {
      let boolean = true;
      for (var i = 0; i < 4; i++) {
        if (a[i] !== b [i]) {
          boolean = false;
        }
      }
      return boolean;
    },
    mouseMove(evt) {
      this.edge_point_clicked = false;
      if (this.selected_spatialunits_location && this.edit_location_point.active) {
        document.getElementById(`location${this.edit_location_point.location_id}_point${this.edit_location_point.point_index}`).focus();
      } else {
        document.getElementById('plan_wrapper').focus();
      }
      if (this.point_move) {
        let left = document.getElementById('plan_wrapper').scrollLeft;
        let top = document.getElementById('plan_wrapper').scrollTop;
        this.moving_point.x = (evt.x - 240 + left) / this.plan_zoom;
        this.moving_point.y = (evt.y - 48 + top) / this.plan_zoom;

        // moving scale
        if (this.plan_scale.points[0].move || this.plan_scale.points[1].move) {
          this.plan_scale.values[0].point.x = (this.plan_scale.points[1].x + this.plan_scale.points[0].x)/2;
          this.plan_scale.values[0].point.y = (this.plan_scale.points[1].y + this.plan_scale.points[0].y)/2;

          let length = Math.sqrt(Math.pow((this.plan_scale.points[1].x - this.plan_scale.points[0].x),2) + Math.pow((this.plan_scale.points[1].y - this.plan_scale.points[0].y),2));
          this.plan_scale.values[0].length = Math.round((length / this.plan_scale.pixcel_per_length) * 1000) / 1000;
        }
        //moving measurement
        if (this.plan_measurement.active) {
          //value
          let points = this.plan_measurement.paths[this.plan_measurement.paths.length-1].points;
          let values = this.plan_measurement.paths[this.plan_measurement.paths.length-1].values;

          //check if close Path
          if (points.length > 3 && Math.abs(points[0].x - this.moving_point.x) < (15 / this.plan_zoom) && Math.abs(points[0].y - this.moving_point.y) < (15 / this.plan_zoom)) {
            this.close_path = true;
          } else {
            this.close_path = false;
          }

          if (points.length > 1 && !this.plan_measurement.rectangle) {
            let x = (points[points.length-1].x + points[points.length-2].x)/2;
            let y = (points[points.length-1].y + points[points.length-2].y)/2;

            let pixel_length = Math.sqrt(Math.pow((points[points.length-1].x - points[points.length-2].x),2) + Math.pow((points[points.length-1].y - points[points.length-2].y),2));
            let length = Math.round((pixel_length / this.plan_scale.pixcel_per_length) * 1000) / 1000;
            values[values.length-1].point.x = x;
            values[values.length-1].point.y = y;
            values[values.length-1].length = length;
          }
        }
        //moving new location
        if (this.show_spatialunits) {
          let points = this.active_location.path.points;

          //check if close Path
          if (points.length > 3 && Math.abs(points[0].x - this.moving_point.x) < (15 / this.plan_zoom) && Math.abs(points[0].y - this.moving_point.y) < (15 / this.plan_zoom)) {
            this.close_path = true;
          } else {
            this.close_path = false;
          }
        }
        this.updateCanvas();
      } else if (this.show_spatialunits) {
        let left = document.getElementById('plan_wrapper').scrollLeft;
        let top = document.getElementById('plan_wrapper').scrollTop;
        this.updateCanvas({x: (evt.x - 240 + left), y: (evt.y - 48 + top)});
      }
      if (this.plan_move.move) {
        document.getElementById('plan_wrapper').scrollLeft = this.plan_move.initial_scrollLeft - (evt.x - this.plan_move.initial_mouse_x);
        document.getElementById('plan_wrapper').scrollTop = this.plan_move.initial_scrollTop - (evt.y - this.plan_move.initial_mouse_y);
      }
      // if (this.ai_mode) {
      //   let left = document.getElementById('plan_wrapper').scrollLeft;
      //   let top = document.getElementById('plan_wrapper').scrollTop;
      //   this.moving_point.x = (evt.x - 240 + left) / this.plan_zoom;
      //   this.moving_point.y = (evt.y - 48 + top) / this.plan_zoom;
      //
      //   let canvas = document.getElementById('plan_pdf');
      //   let factor = (canvas.width / 1000);
      //   this.canvas_factor = factor;
      //
      // }
    },
    planMoveStart(evt) {
      this.plan_move.move = true;
      this.plan_move.initial_mouse_x = evt.x;
      this.plan_move.initial_mouse_y = evt.y;
      this.plan_move.initial_scrollLeft = document.getElementById('plan_wrapper').scrollLeft;
      this.plan_move.initial_scrollTop = document.getElementById('plan_wrapper').scrollTop;

    },
    zoomWheel(evt) {
      evt.preventDefault();
      // let point_x = document.getElementById('plan_wrapper').scrollLeft + evt.x - 240;
      // let point_y = document.getElementById('plan_wrapper').scrollTop + evt.y - 48;
      if (evt.wheelDelta > 0) {
        this.plan_zoom = this.plan_zoom + 0.3;
        document.getElementById('plan_wrapper').scrollLeft = document.getElementById('plan_wrapper').scrollLeft + document.getElementById('plan_wrapper').scrollLeft * 0.15;
        document.getElementById('plan_wrapper').scrollTop = document.getElementById('plan_wrapper').scrollTop + document.getElementById('plan_wrapper').scrollTop * 0.15;
        // document.getElementById('plan_wrapper').scrollLeft = document.getElementById('plan_wrapper').scrollLeft + (point_x * 1.3 - point_x);
        // document.getElementById('plan_wrapper').scrollTop = document.getElementById('plan_wrapper').scrollTop + (point_y * 1.3 - point_y);

        // setTimeout(function () {
        //   document.getElementById('plan_wrapper').scrollLeft = document.getElementById('plan_wrapper').scrollLeft + point_x * 1.3 - point_x;
        //   document.getElementById('plan_wrapper').scrollTop = document.getElementById('plan_wrapper').scrollTop + point_y * 1.3 - point_y;
        //
        // }, 10);
      } else {
        this.plan_zoom = this.plan_zoom - 0.3;
        document.getElementById('plan_wrapper').scrollLeft = document.getElementById('plan_wrapper').scrollLeft - document.getElementById('plan_wrapper').scrollLeft * 0.15;
        document.getElementById('plan_wrapper').scrollTop = document.getElementById('plan_wrapper').scrollTop - document.getElementById('plan_wrapper').scrollTop * 0.15;

        // document.getElementById('plan_wrapper').scrollLeft = document.getElementById('plan_wrapper').scrollLeft - (point_x * 1.3 - point_x);
        // document.getElementById('plan_wrapper').scrollTop = document.getElementById('plan_wrapper').scrollTop - (point_x * 1.3 - point_x);

      }
    },
    // measurement
    togglePlanMeasure(evt, end_measurement, complement_rect) {
      //end measurement
      if (end_measurement) {
        this.plan_measurement.active = false;
        this.plan_measurement.paths.splice(0, this.plan_measurement.paths.length);
      }
      //new measurement path
      else {
        let left = document.getElementById('plan_wrapper').scrollLeft;
        let top = document.getElementById('plan_wrapper').scrollTop;

        this.plan_measurement.paths.push({area: false, area_value: {x: 0, y: 0, value: 0}, rectangle: this.plan_measurement.rectangle, points: [], values: []});

        //create first path
        if (this.plan_measurement.paths.length === 1) {
          this.plan_measurement.paths[0].points.push({x: (evt.x - 240 + left) / this.plan_zoom, y: (evt.y - 48 + top) / this.plan_zoom});
          this.moving_point = this.plan_measurement.paths[0].points[this.plan_measurement.paths[0].points.length-1];
        }
        // create  path and close old path
        else {
          let points = this.plan_measurement.paths[this.plan_measurement.paths.length-2].points;
          let values = this.plan_measurement.paths[this.plan_measurement.paths.length-2].values;
          let path = this.plan_measurement.paths[this.plan_measurement.paths.length-1];


          // remove last value
          if (!this.close_path && !this.plan_measurement.rectangle) {
            values.splice(values.length-1,1);
          }
          //move last point to new path
          path.points.push(points.splice(points.length-1,1)[0]);
          if (points.length === 1) {
            points.splice(0,1);
          }
          //calculate areas
          if (this.close_path || complement_rect) {
            let old_path = this.plan_measurement.paths[this.plan_measurement.paths.length-2];

            old_path.area = true;
            let area = this.calcPolygonArea(old_path.points);
            old_path.area_value.value = area;
            let centroid = this.calcPolygonCentroid(old_path.points, area);
            old_path.area_value.x = centroid.x;
            old_path.area_value.y = centroid.y;
          }

          this.moving_point = path.points[path.points.length-1];
        }
        this.plan_measurement.active = true;
      }
      this.updateCanvas();
    },
    setMeasurePoint(evt, complement_rect) {
      if (!this.plan_move.moved) {
      //new point
      let left = document.getElementById('plan_wrapper').scrollLeft;
      let top = document.getElementById('plan_wrapper').scrollTop;

      let points = this.plan_measurement.paths[this.plan_measurement.paths.length-1].points;
      let values = this.plan_measurement.paths[this.plan_measurement.paths.length-1].values;

      points.push({x: (evt.x - 240 + left) / this.plan_zoom, y: (evt.y - 48 + top) / this.plan_zoom});
      this.moving_point = points[points.length-1];

      if (!this.plan_measurement.rectangle || complement_rect) {
        //value
        let x = (points[points.length-1].x + points[points.length-2].x)/2;
        let y = (points[points.length-1].y + points[points.length-2].y)/2;

        let pixel_length = Math.sqrt(Math.pow((points[points.length-1].x - points[points.length-2].x),2) + Math.pow((points[points.length-1].y - points[points.length-2].y),2));
        let length = Math.round((pixel_length / this.plan_scale.pixcel_per_length) * 1000) / 1000;
        values.push({point: {x: x, y: y}, length: length});
      }
      }
    },
    complementRectangle(evt) {
      if (!this.plan_move.moved) {
        let left = document.getElementById('plan_wrapper').scrollLeft;
        let top = document.getElementById('plan_wrapper').scrollTop;
        let path = this.plan_measurement.paths[this.plan_measurement.paths.length-1];

        path.points.splice(1, 1);

        this.setMeasurePoint({x: evt.x, y: (path.points[0].y * this.plan_zoom + 48 - top)});
        this.setMeasurePoint({x: evt.x, y: evt.y}, true);
        this.setMeasurePoint({x: (path.points[0].x * this.plan_zoom + 240 - left), y: evt.y}, true);
        this.setMeasurePoint({x: evt.x, y: evt.y});

        this.togglePlanMeasure(evt, false, true);
      }
    },


    // edit location
    startNewLocation(evt, spatial_unit_id) {
      this.active_location = {
        id: 'create',
        plan_id: this.selected_plan.id,
        spatial_unit_id: spatial_unit_id,
        path: {
          area_values: {x: 0, y: 0, surface: 0, perimeter: 0},
          points: [],
          values: [],
        }
      };
      let left = document.getElementById('plan_wrapper').scrollLeft;
      let top = document.getElementById('plan_wrapper').scrollTop;

      this.active_location.path.points.push({x: (evt.x - 240 + left) / this.plan_zoom, y: (evt.y - 48 + top) / this.plan_zoom});
      this.moving_point = this.active_location.path.points[this.active_location.path.points.length-1];

      this.updateCanvas();
    },
    endNewLocation() {
      let points = this.active_location.path.points;
      //create location
      if (points.length === 3 || this.close_path) {
        //calculate rectangle points
        let active_location_copy = JSON.parse(JSON.stringify(this.active_location));
        if (this.close_path) {
          active_location_copy.path.points.splice(active_location_copy.path.points.length-1,1);
        } else {
          let rectangle_points = [
            {x: points[0].x, y: points[0].y},
            {x: points[1].x, y: points[0].y},
            {x: points[1].x, y: points[1].y},
            {x: points[0].x, y: points[1].y},
          ];
          active_location_copy.path.points = rectangle_points;
        }
        if (active_location_copy.spatial_unit_id === 'create') {
          this.createUObject({
            url: [
              {[this.selected_tree_element.type]: this.selected_tree_element.id},
              {spatialunits: ''},
              {showWithEntitiesNormalized: ''}
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            u_object: JSON.parse(JSON.stringify(Object.assign(this.spatial_elements[5], {order_index: 5, parent: {type: this.selected_tree_element.type, id: this.selected_tree_element.id}})))
          }).then((spatial_unit_id) => {
              active_location_copy.spatial_unit_id = spatial_unit_id;
              this.createUDObject({
                url: [
                  {spatialunits: spatial_unit_id},
                  {locations: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                resp_data: {
                  locations: [
                      JSON.parse(JSON.stringify(active_location_copy))
                  ]
                }
              }).then((location_id) => {
                this.updateTreeOrderIndex({type: this.selected_tree_element.type, id: this.selected_tree_element.id});
                active_location_copy.id = location_id;
                this.locations.push(active_location_copy);
                this.active_location.id = 'create';
                this.active_location.spatial_unit_id = 'create';
                points.splice(0, points.length, points[points.length-1]);
                this.updateCanvas();
              });
            });
        } else {
          this.createUDObject({
            url: [
              {spatialunits: active_location_copy.spatial_unit_id},
              {locations: ''},
              {showWithEntitiesNormalized: ''}
            ],
            resp_data: {
              locations: [
                JSON.parse(JSON.stringify(active_location_copy))
              ]
            }
          }).then((location_id) => {
            active_location_copy.id = location_id;
            this.locations.push(JSON.parse(JSON.stringify(active_location_copy)));
            this.active_location.id = 'create';
            this.active_location.spatial_unit_id = 'create';
            points.splice(0, points.length, points[points.length-1]);
            this.updateCanvas();
          });
        }
      }
      else {
        // reset localisazion
        points.splice(0, points.length, points[points.length-1]);
        this.updateCanvas();
      }
    },
    // setLocalisationPoint(evt) {
    //   if (!this.plan_move.moved) {
    //   //new point
    //   let left = document.getElementById('plan_wrapper').scrollLeft;
    //   let top = document.getElementById('plan_wrapper').scrollTop;
    //
    //   let points = this.active_location.path.points;
    //
    //   points.push({x: (evt.x - 240 + left) / this.plan_zoom, y: (evt.y - 48 + top) / this.plan_zoom});
    //   this.moving_point = points[points.length-1];
    //   }
    // },
    insertLocalisationPoint(evt, index) {
      let left = document.getElementById('plan_wrapper').scrollLeft;
      let top = document.getElementById('plan_wrapper').scrollTop;

      let new_point = {
        x: (evt.x - 240 + left) / this.plan_zoom,
        y: (evt.y - 48 + top) / this.plan_zoom
      };

      this.selected_spatialunits_location.path.points.splice(index+1, 0, new_point);
      this.edit_location_point = {
        active: true,
        location_id: this.selected_spatialunits_location.id,
        point_index: index+1
        };
      this.moving_point = this.selected_spatialunits_location.path.points[index+1];
    },
    localisazionPointKeyUp(evt, index) {
      if (this.selected_spatialunits_location && this.edit_location_point.active &&
          (evt.key === 'Backspace' || evt.key === 'Delete')
      ) {
        if (this.selected_spatialunits_location.path.points.length > 1) {
          this.selected_spatialunits_location.path.points.splice(index, 1);
          this.updateUDObject({
            url: [
              {locations: this.selected_spatialunits_location.id},
            ],
            update: {
              path: JSON.parse(JSON.stringify(this.selected_spatialunits_location.path))
            }
          });
        } else {
          this.deleteUDObject({
            url: [
              {spatialunits: this.selected_spatialunits_location.spatial_unit_id},
              {locations: this.selected_spatialunits_location.id},
            ],
          }).then(() => {
            this.setLocations();
          });
        }
        this.edit_location_point = {
          active: false,
          location_id: -1,
          point_index: -1
        };
        this.updateCanvas();
      }
    },
    edgePointMouseDown(point) {
      this.moving_point.x = point.x;
      this.moving_point.y = point.y;
      this.edge_point_clicked = true;
    },
    calcPolygonArea(points) {
      var total = 0;

      for (var i = 0, l = points.length; i < l; i++) {
        var addX = points[i].x;
        var addY = points[i == points.length - 1 ? 0 : i + 1].y;
        var subX = points[i == points.length - 1 ? 0 : i + 1].x;
        var subY = points[i].y;

        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
      }
      let area = Math.abs(total / (this.plan_scale.pixcel_per_length * this.plan_scale.pixcel_per_length));
      area = Math.round(area * 100) / 100;
      return area;
    },
    calcPolygonCentroid(points) {
      let pts = JSON.parse(JSON.stringify(points));
      let first = pts[0];
      let last = pts[pts.length-1];
      if (first.x !== last.x || first.y !== last.y) {
        pts.push(first);
      }
      let twicearea = 0;
      let x = 0;
      let y = 0;
      let nPts = pts.length;

      for ( let i = 0, j = nPts-1; i < nPts; j = i++ ) {
      let p1 = pts[i];
      let p2 = pts[j];
      let f = p1.x * p2.y - p2.x * p1.y;
      twicearea += f;
      x += ( p1.x + p2.x ) * f;
      y += ( p1.y + p2.y ) * f;
      }
      let g = twicearea * 3;
      return { x: x/g, y: y/g};
    },
    getElementsIcon(type) {
      let icon = '';
      switch (type) {
        case 'sites':
          icon = 'select_all';
          break;
        case 'spatialzones':
          icon = 'schema';
          break;
        case 'buildings':
          icon = 'domain';
          break;
        case 'buildingstoreys':
          icon = 'format_line_spacing';
          break;
        case 'spaces':
          icon = 'crop_free';
          break;
        case 'spatialunits':
          icon = 'list_alt';
          break;
      }
      return icon;
    },
    updateTreeOrderIndex(parent) {
      let child_elements = JSON.parse(JSON.stringify(this.getChildElements({parent_type: parent.type, parent_id: parent.id})));
        let child_elements_sorted = child_elements.sort(function (a,b) {
          return a.order_index - b.order_index;
        });
        child_elements_sorted.forEach((element, index) => {
          this.updateUObject({
            url: [
              {[element.type]: element.id}
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            update: {
              order_index: (index + 1) * 10
            }
          });
        });
    },
    showSpatialElement(parent_type, children_type) {
      let boolean = true;
      switch (parent_type) {
        case 'projects':
          boolean = ['sites'].includes(children_type.split('#')[0]);
          break;
        case 'sites':
          boolean = ['sites', 'spatialzones', 'buildings', 'buildingstoreys', 'spaces', 'spatialunits'].includes(children_type.split('#')[0]);
          break;
        case 'spatialzones':
          boolean = ['spatialzones', 'spatialunits'].includes(children_type.split('#')[0]);
          break;
        case 'buildings':
          boolean = ['buildings', 'buildingstoreys', 'spaces', 'spatialunits'].includes(children_type.split('#')[0]);
          break;
        case 'buildingstoreys':
          boolean = ['buildingstoreys', 'spaces', 'spatialunits'].includes(children_type.split('#')[0]);
          break;
        case 'spaces':
          boolean = ['spaces', 'spatialunits'].includes(children_type.split('#')[0]);
          break;
        case 'spatialunits':
          boolean = false;
          break;
      }
      return boolean;
    },
  }
};
